import posthog from 'posthog-js'

let initialised = false

const initPostHog = (key, host) => {
  if (initialised) {
    return
  }

  posthog.init(key, {
    api_host: host,
    capture_pageview: 'history_change',
    autocapture: true,
    disable_session_recording: true,
    disable_surveys: true,
    disable_product_tours: true,
    disable_conversations: true,
    capture_exceptions: false,
    secure_cookie: true,
  })
  initialised = true
}

const identifyUser = ({ id, company, roles }) => {
  if (
    posthog.get_distinct_id() !== String(id) &&
    posthog.get_property('$user_state') === 'identified'
  ) {
    posthog.reset()
  }

  posthog.identify(id, {
    company_id: company.id,
    company_name: company.name,
    role: roles
      .map(({ id: roleId }) => roleId)
      .sort()
      .join(','),
  })
}

const captureEvent = (name, properties) => {
  if (!initialised) {
    return
  }

  posthog.capture(name, properties)
}

const resetPostHog = () => {
  if (!initialised) {
    return
  }

  posthog.set_config({ capture_pageview: false })
  posthog.reset()
  initialised = false
}

export { initPostHog, identifyUser, captureEvent, resetPostHog }
